module.exports = __webpack_public_path__ + "img/ava_none.73b62995.jpg";